import { acme } from '@axo/shared/data-access/types';
import { Dispatch, SetStateAction } from 'react';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface State {
  search: acme.ArchiveSearchReq;

  actions: {
    replaceSearch: Dispatch<SetStateAction<State['search']>>;
  };
}

const useState = create<State>()(
  persist(
    (set) => ({
      search: {
        query: '',
        limit: 50,
      },

      actions: {
        replaceSearch: (action) =>
          set((state) => ({
            search:
              typeof action === 'function' ? action(state.search) : action,
          })),
      },
    }),
    {
      name: 'ace.archivesearch',
      partialize: ({ actions: _, ...state }) => state,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useArchiveSearch = () => useState((state) => state.search);

export const useArchiveSearchActions = () => useState((state) => state.actions);
